// ─────────────────────────────────────────────────────────────────────────────
// TEMP: Access control is disabled — every authenticated user has full access.
//
// This mirrors the backend `ACCESS_CONTROL_ENABLED` env flag. While it is `false`,
// `canAccess()` always returns true, so all nav items, routes, and role-gated UI
// are visible to everyone. Flip this to `true` (and refine `canAccess`) once the
// real RBAC model is decided — that is the single place the frontend gates hang off.
// ─────────────────────────────────────────────────────────────────────────────
export const ACCESS_CONTROL_ENABLED = false;

/**
 * Returns whether `role` is allowed given `allowedRoles`.
 * No-op (always true) while ACCESS_CONTROL_ENABLED is false.
 */
export function canAccess(role: string, allowedRoles: string[]): boolean {
  if (!ACCESS_CONTROL_ENABLED) return true;
  return allowedRoles.includes(role);
}
